export const DEFAULT_SORTING_OPTIONS = {
  direction: undefined,
  active: undefined
};
